import styled from '@emotion/styled';
import { Stack } from '@mui/material';

import { theme } from '@/shared/design-system';

export const AddressParts = styled(Stack)({
  flexDirection: 'column',
  gap: '8px',
  paddingLeft: '20px',
  marginLeft: '8px',
  borderLeft: `1px solid ${theme.colors.border.default}`,
});
